import { render, staticRenderFns } from "./Learn-Inscript-Hindi.vue?vue&type=template&id=001ba4fd&"
import script from "./Learn-Inscript-Hindi.vue?vue&type=script&lang=js&"
export * from "./Learn-Inscript-Hindi.vue?vue&type=script&lang=js&"
import style0 from "./Learn-Inscript-Hindi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports